<template lang="pug">
  .wrap
    h4 Tiempos
    .radio-btn-group
      .radio
        input(type='radio', name='radio', value='tiemposAcumulados', checked, v-model="checked")#acumulados
        label(for="acumulados") Acumulados
      .radio
        input(type='radio', name='radio', value='tiemposPrime', v-model="checked")#prime
        label(for="prime") Especial
</template>
<script>

import { mapActions } from 'vuex'

export default {
  data() {
    return {
      checked: ''
    }
  },
  mounted(){
    // console.log(this.primes)
    this.checked = 'tiemposAcumulados'
  },
  watch: {
    checked(newactive, oldactive) {
      // console.log(newactive)
      this.setActiveType(newactive)
    },
  },
  methods: {
    ...mapActions([
      'setActiveType'
    ])
  }
}
</script>
<style lang="scss" scoped>

.wrap{
  display: flex;
  align-items: center;
}
.radio-btn-group {
  display: flex;

  .radio {
    margin: 0 .25rem;

    label {
      background: #fff;
      border: 1px solid #ddd;
      padding: .5rem 1.25rem;
      border-radius: 5px;
      cursor: pointer;
      color: #444;
      transition: box-shadow 400ms ease;

      &:hover {
        box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
      }
    }

    input[type="radio"] {
      display: none;
    }

    input[type="radio"]:checked+label {
      background: #2196F3;
      color: #fff;
      border-color: #2196F3;
    }
  }
}
</style>

